module.exports = __webpack_public_path__ + "media/images/emblems/Genolier-coat_of_arms-fe8b94feed39144d2945f9d8a4a8fbf1.svg";